import { Grid, Paper, styled } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';

export const ChartRefreshButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(0.5),
  right: theme.spacing(1),
  display: 'block'
}));

export const ChartPaperContainer = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  padding: 0,
  position: 'relative',
  transition: 'height 0.3s ease',
  overflow: 'visible'
}));

export const ChartWrapper = styled(Grid, { shouldForwardProp: prop => prop !== 'translate' })(({ theme, translate }) => ({
  position: 'relative',
  transition: 'transform 0.3s ease',
  border: 0,
  transform: translate ? `translateY(-${theme.spacing(6)})` : {}
}));
